<template>
	<div class="font-prevent" :id="idName"></div>
</template>

<script>
import * as brace from 'brace';
import 'brace/ext/modelist';
import 'brace/ext/themelist';
import 'brace/ext/searchbox';

const modelist = brace.acequire('ace/ext/modelist');
const themelist = brace.acequire('ace/ext/themelist');
brace.acequire('ace/ext/searchbox');

const regMap = {
	isInt: new RegExp('^\\d+$'),
};
export default {
	data: () => ({
		editor: null,
		idName:
			'vue-brace-' +
			Math.random()
				.toString()
				.substr(2),
	}),
	props: {
		mode: {
			type: String,
			default: 'json',
			validator: val =>
				modelist.modes.findIndex(mode => mode.name === val) > -1,
		},
		theme: {
			type: String,
			default: 'github',
			validator: val =>
				themelist.themes.findIndex(theme => theme.name === val) > -1,
		},
		// todo editor split
		// fontsize: {
		//   type: String,
		//   default: "22px",
		//   validator: val => true //parseInt(val) > 11 && parseInt(val) < 25
		// },
		codefolding: {
			type: String,
			default: 'markbegin',
			validator: val => ['manual', 'markbegin', 'markbeginend'].includes(val),
		},
		// todo key binding
		softwrap: {
			type: String,
			default: 'free',
			validator: val => ['off', 'free'].includes(val) || regMap.isInt.test(val),
		},
		selectionstyle: {
			type: String,
			default: 'text',
			validator: val => ['text', 'line'].includes(val),
		},
		highlightline: {
			type: Boolean,
			default: true,
		},
		initialCode: {
			type: String,
			default: '',
		},
		// todo a lot of other things...
	},
	methods: {
		setMode() {
			let modeObj = modelist.modesByName[this.mode];
			if (modeObj) {
				require('brace/mode/' + modeObj.name);
				this.editor.getSession().setMode(modeObj.mode);
			}
		},
		setTheme() {
			let themeObj = themelist.themesByName[this.theme];
			if (themeObj) {
				// require("brace/theme/" + themeObj.name);
				import('brace/theme/' + themeObj.name).then(() => {
					this.editor.setTheme(themeObj.theme);
				});
			}
		},
		emitCode() {
			this.$emit('code-change', this.editor.getValue());
		},
	},
	created() {
		this.idName += '-' + this._uid;
	},
	mounted() {
		// console.log("brace mounted");
		this.editor = brace.edit(this.idName);
		// console.log("[Editor] Themes ", themelist.themes.map(t => t.name).join(", "));
		this.setMode();
		this.setTheme();
		this.editor.setOptions({
			fontSize: '22px',
		});
		this.editor.$blockScrolling = Infinity;
		// console.log("mounted brace edtr");
		if (this.initialCode != '') {
			this.editor.setValue(this.initialCode);
		}
		this.editor.getSession().on('change', this.emitCode);
		this.$emit('setHandler', {
			setValue: newVal => {
				if (!newVal) {
					newVal = '';
				}
				this.editor.setValue(newVal);
				this.editor.clearSelection();
			},
			clear: () => {
				this.editor.setValue('');
			},
		});
	},
	watch: {
		mode() {
			this.setMode();
		},
		theme() {
			this.setTheme();
		},
		// fontsize(newVal) {
		//   this.editor.setFontSize(newVal);
		// },
		codefolding(newVal) {
			this.editor.session.setFoldStyle(newVal);
			this.editor.setShowFoldWidgets(newVal !== 'manual');
		},
		softwrap(newVal) {
			this.editor.setOption('wrap', newVal);
		},
		selectionstyle(newVal) {
			this.editor.setOption('selectionStyle', newVal);
		},
		highlightline(newVal) {
			this.editor.setHighlightActiveLine(newVal);
		},
	},
};
</script>

<style>
.font-prevent {
	font-size: 14px !important;
	/* font-family: monospace;
        text-rendering: optimizeLegibility */
}
</style>
